module.exports = __webpack_public_path__ + "static/media/w.064b75e0.jpg";